import React from 'react'
import {Flex} from '/app/src/component';

import style from './style.css'

export default class SortButton extends React.Component {
    render() {
        const {icon, text, onClick, active} = this.props
        return (
            <Flex center className={style.ButtonContainer} border={active ? '3px solid #2ea2d2' : '3px solid transparent'} bg='grey1' onClick={onClick}>
                <Flex shrink={0}>
                    {icon}
                </Flex>
                <Flex grow center>
                    {text}
                </Flex>
            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Questions/SortButton/index.js